'use strict';

var _ = require('underscore'),
    dangerouslyStripHTML = require('./dangerouslyStripHTML');

function isEmptyishHTML(html) {
  return _.isEmpty(dangerouslyStripHTML(html).trim());
}

module.exports = isEmptyishHTML;



/** WEBPACK FOOTER **
 ** ./utils/isEmptyishHTML.js
 **/